




































































import Vue from 'vue'
import Component from 'vue-class-component'
import { IDateItem, IFilterItem, ISearchParams } from '@app/componentlib/common/types/JobSearchTypes'
import { ILocationItem } from '@app/componentlib/common/types/LocationTypes'
import { JobSearchModule } from '@app/componentlib/src/store/modules/jobSearch'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { LocationModule } from '@app/componentlib/src/store/modules/locationdata'

@Component<JobSavedSearches>({
  props: {
    savedSearchesRetrieved: Boolean
  }
})

export default class JobSavedSearches extends Vue {
  /**
   * Props variables
   */
  savedSearchesRetrieved: boolean = false


  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get locationTypeahead () : ILocationItem[] {
    return LocationModule.locationTypeahead!
  }

  get jobCategories (): IFilterItem[] | undefined {
    return JobSearchModule.searchFilters?.JobCategoryFilters
  }

  get industries (): IFilterItem[] | undefined {
    return JobSearchModule.searchFilters?.IndustryFilters
  }

  get careers (): IFilterItem[] | undefined {
    return JobSearchModule.searchFilters?.CareerFilters
  }

  get dates (): IDateItem[] {
    return JobSearchModule.dates
  }

  get savedSearches (): ISearchParams[] | undefined {
    return JobSearchModule.savedSearches
  }

  get isMobile (): boolean {
    return AppModule.isMobile
  }


  /**
   * Methods
   */
  initiateSearch(searchParams: ISearchParams) {
    // make a copy of searchParams
    const tempSearchParams = JSON.parse(JSON.stringify(searchParams))
    const { ZipCode, Range, Country } = tempSearchParams

    // Empty location so we are sure we don't previous one
    LocationModule.setLocation([])
    if (tempSearchParams !== undefined) {
      // Get country from from list of countries
      let tempCountry = LocationModule.countries.find(country => country.countryCode === Country)
        if (tempCountry !== undefined && tempCountry.countryCode !== LocationModule.selectedCountry.countryCode) {
          // Set the new country as the selected country, and then set map information
          LocationModule.setSelectedCountry(tempCountry)
          let mapInfo = LocationModule.mapInformations.find(map => map.Country === tempCountry?.countryCode)
          if (mapInfo !== undefined) {
            LocationModule.setMapInformation(mapInfo)
          }
        }

      if (ZipCode !== undefined && ZipCode !== null && ZipCode !== '') {
        // Find the country in search params and set it as the selectedCountry
        let item = this.locationTypeahead.find(item => item.postal === ZipCode?.replace(" ", ""))
        // Get location from savedSearch and set it in store
        if (item !== undefined) {
          LocationModule.setLocation([{
            type: "",
            postal: ZipCode,
            city: item.city,
            mapViewText: this.isMobile === false ?
              (item.displayText.replace('$', '') + " - Radius: " + Range + " km") :
              (item.displayText.replace('$', '')),
            radius: Range,
            lat: 0,
            lon: 0
          }])
        }
      }

      // set the new updated searchParam and initiate a search
      this.scrollToTop()
      JobSearchModule.setSearchParamsFromSaved(tempSearchParams)
      this.$emit('startSearch', true, true)
    }
  }

  // Saved search only have the filters id, search for its name to display it
  displayFilterName(listOfFilters: string[], listToIterate: IFilterItem[]) {
    let tempString = []
    for(let item in listToIterate) {
      for(let item2 in listOfFilters) {
        if (listToIterate[item].Id.toString() === listOfFilters[item2].toString()) {
          tempString.push(listToIterate[item].Name)
        }
      }
    }
    return tempString
  }

  // Date only have its id, search for its name to display it
  displayDateName(dateId: string) {
    return this.dates.find((date: IDateItem) => date.Id.toString() === dateId)?.Name
  }

  deleteSavedSearch(id: number) {
    this.$emit('deleteSavedSearch', id)
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
}
